import type { SimState } from './state';

const ALPHABET_SIZE = 26;

/** Spreadsheet-column lettering: a, b, … z, aa, ab — so a channel always has a name short enough to read off a tile. */
function letters(index: number): string {
  let name = '';
  for (let n = index; n >= 0; n = Math.floor(n / ALPHABET_SIZE) - 1) {
    name = String.fromCharCode(97 + (n % ALPHABET_SIZE)) + name;
  }
  return name;
}

/**
 * The lowest name not currently on the board, so erasing `b$` and building again reuses `b$`
 * rather than drifting towards names the player has never seen.
 */
export function nextSubjectName(taken: readonly string[]): string {
  const used = new Set(taken);
  for (let index = 0; ; index++) {
    const name = `${letters(index)}$`;
    if (!used.has(name)) return name;
  }
}

export function subjectNames(state: SimState): string[] {
  return Object.values(state.subjects).map((subject) => subject.name);
}
